import { render, staticRenderFns } from "./MatchOptionsMatchResults.vue?vue&type=template&id=e65ea49a&scoped=true&"
import script from "./MatchOptionsMatchResults.vue?vue&type=script&lang=js&"
export * from "./MatchOptionsMatchResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e65ea49a",
  null
  
)

export default component.exports